var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"checkbox-center",attrs:{"primary":"","hide-details":""},on:{"change":_vm.updateValue},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }